import BaseApiAction from '@Actions/base-api-action';

export default class UpdatePin extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'auth-temp-updatePin',
      payload: {
        pin: this._payload.pin,
        ...this._payload
      },
    });
  }
  
  onSuccess(data) {
    super.onSuccess(data);
    // Todo - Return this logic after notifications refactor
    // this._dispatch({
    //   type: Actions.CoreActions.UpdateState,
    //   payload: {
    //     user: {
    //       hasPin: true
    //     }
    //   }
    // })
  };
}
